import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

export default function Erro404() {
    const { push } = useHistory();
    const { t } = useTranslation();

    return (
        <div className="d-flex flex-column justify-content-center align-items-center" 
             style={{ minHeight: '80vh' }}>
            <h4 className="mb-2">{t('erro404.titulo')}</h4>
            <p className="text-muted mb-4">
                {t('erro404.texto')}
            </p>
            <button className="btn btn-primary" onClick={() => push('/inicio')}>
                {t('erro404.botão')}
            </button>
        </div>
    );
}